<template>
  <div class="usage-terms-form-optin"
       :class="{ 'usage-terms-form-optin_error': hasError }">

    <div class="usage-terms-form-optin-body"
         :class="{ 'usage-terms-form-optin-body_open' : showBody }">
      <div class="usage-terms-form-option-body-header">
        <label class="usage-terms-form-option-body-header-label"
               for="Opt In">{{ optinLabel }} <i class="mdi mdi-help-circle-outline pointer"
             v-tooltip="$t('message.termsOfUse.message.tooltipOptIn')"></i></label>

        <div v-if="!admin"
             class="usage-terms-form-option-body-header-optional">
          <app-toggle class="usage-terms-form-option-body-header-optional-toggle"
                      :value="value.optionalOptinAccepting"
                      @input="emitVal('optionalOptinAccepting', $event)"></app-toggle>

          <p class="usage-terms-form-option-body-header-optional-text">{{$t('message.termsOfUse.message.optionalAcceptance')}} <i class="mdi mdi-help-circle-outline pointer"
               v-tooltip="$t('message.termsOfUse.message.tooltipOptionalAcceptance')"></i></p>
        </div>
      </div>
      <v-textarea class="usage-terms-form-optin-body-text"
                  v-validate="termOptinTextValidation"
                  :value="value.text"
                  :no-resize="true"
                  :rows="5"
                  :counter="255"
                  name="Opt In"
                  @input="emitVal('text', $event)">
      </v-textarea>

      <p v-if="hasError"
         class="usage-terms-form-optin-body-error">{{ errorMessage }}</p>

    </div>

    <button v-if="!admin"
            class="usage-terms-form-optin-action pointer"
            type="button"
            @click="toggleShowBody"><i :class="`usage-terms-form-optin-action-icon mdi ${actionInfos.icon}`"></i>{{ actionInfos.text }}</button>

  </div>
</template>

<script>
    import { cloneDeep } from 'lodash'
    import AppToggle from '@components/Toggle'


    export default {
        components: {
          AppToggle
        },

        inject: {
          $validator: '$validator'
        },

        props: {
          value: {
            type: Object,
            default() {
              return {
                text: undefined,
                optionalOptinAccepting: false
              }
            }
          },
          admin: {
            type: Boolean,
            default: false
          }
        },

        data() {
            return {
              showBody: false,
            }
        },

        computed: {
          actionInfos() {
            return this.showBody ? {
              icon: 'mdi-minus-circle',
              text: this.$t('message.termsOfUse.message.deactivateOptIn')
            } : {
              icon: 'mdi-plus-circle',
              text: this.$t('message.termsOfUse.message.registerOptIn')
            }
          },
          optinLabel() {
            return this.admin ? this.$t('message.termsOfUse.message.optIn') : this.$t('message.termsOfUse.message.optInOptional')
          },
          termOptinTextValidation() {
            return this.admin ? 'required' : ''
          },
          hasError() {
            return !!this.$validator.errors.collect('Opt In').length
          },
          errorMessage() {
            return this.$validator.errors.collect('Opt In')[0]
          }
        },

        methods: {
          toggleShowBody() {
            this.showBody = !this.showBody

            if(!this.showBody) {
              this.emitFullVal({
                text: undefined,
                optionalOptinAccepting: false
              })
            }
          },
          emitVal(key, val) {
            const value = cloneDeep(this.value)

            value[key] = val

            this.$emit('input', value)
          },
          emitFullVal(val) {
            this.$emit('input', val)
          }
        },


        mounted() {
          if(this.value.text || this.admin) {
            this.showBody = true
          }
        },

        beforeDestroy() {
        },
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.usage-terms-form-optin {
  margin-bottom: 50px !important;

  .usage-terms-form-optin-body {
    max-height: 0;
    overflow: hidden;
    margin-bottom: 15px;
    transition: max-height 0.5s ease-in-out;

    .usage-terms-form-option-body-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;

      .usage-terms-form-option-body-header-label {
        margin-left: 10px;
        margin-bottom: 0;
        color: #707070;
      }

      .usage-terms-form-option-body-header-optional {
        display: flex;
        align-items: center;

        .usage-terms-form-option-body-header-optional-toggle {
          display: flex;
          align-items: center;
          margin-right: 10px;
        }

        .usage-terms-form-option-body-header-optional-text {
          margin: 0;
          color: #707070;
        }
      }
    }

    .usage-terms-form-optin-body-text {
      padding-left: 20px;
      padding-right: 20px;
      border: 1px solid #c4c4c4;
      border-radius: 20px;

      caret-color: auto !important;

      ::v-deep .v-input__slot {
        &::before {
          border: none;

          &:active {
            border: none;
          }
        }
        &::after {
          border: none;
        }
      }
    }

    .usage-terms-form-optin-body-error {
      font-size: 12px;
      color: red;
      margin-top: 5px;
    }

    &.usage-terms-form-optin-body_open {
      max-height: 300px;
    }
  }

  .usage-terms-form-optin-action {
    color: $primary;
    border-bottom: 1px solid $primary;
    display: flex;
    align-items: center;

    .usage-terms-form-optin-action-icon {
      display: flex;
      align-items: center;
      margin-right: 5px;
    }
  }

  &.usage-terms-form-optin_error {
    .usage-terms-form-option-body-header {
      .usage-terms-form-option-body-header-label {
        color: red;
      }
    }

    .usage-terms-form-optin-body-text {
      border-color: red;
    }
  }
}
</style>
